import { ChromaVectorSyncFeaturePage } from "..";

/** 同步向量库页面。 */
export function ChromaVectorSyncPage() {
  return <ChromaVectorSyncFeaturePage />;
}
